export var ApplePayContactFieldObj = ["email", "name", "phone", "postalAddress", "phoneticName"];
/** @internal */
export var validateApplePayContactField = function (applePayContactField) {
    return ApplePayContactFieldObj.includes(applePayContactField);
};
